export default __webpack_public_path__ + "static/media/marketing.7f7830e6.png";